import Phaser from 'phaser'
import { LongPressGesture } from './longPressGesture'

export interface LongPressOptions {
  durationMs?: number
  moveTolerance?: number
  onComplete: () => void
}

export function attachLongPress(
  scene: Phaser.Scene,
  zone: Phaser.GameObjects.Zone,
  options: LongPressOptions,
): { cancel: () => void } {
  const gesture = new LongPressGesture(options.durationMs ?? 3000)
  const moveTolerance = options.moveTolerance ?? 16
  let origin: { x: number; y: number } | null = null

  const cancel = () => {
    origin = null
    gesture.cancel()
  }
  const onDown = (pointer: Phaser.Input.Pointer) => {
    origin = { x: pointer.x, y: pointer.y }
    gesture.start(scene.time.now)
  }
  const onMove = (pointer: Phaser.Input.Pointer) => {
    if (!origin) return
    if (Math.hypot(pointer.x - origin.x, pointer.y - origin.y) > moveTolerance) cancel()
  }
  const onUpdate = (time: number) => {
    if (!gesture.consume(time)) return
    origin = null
    options.onComplete()
  }
  const cleanup = () => {
    cancel()
    zone.off('pointerdown', onDown)
    scene.input.off('pointerup', cancel)
    scene.input.off('pointermove', onMove)
    scene.events.off(Phaser.Scenes.Events.UPDATE, onUpdate)
  }

  zone.on('pointerdown', onDown)
  scene.input.on('pointerup', cancel)
  scene.input.on('pointermove', onMove)
  scene.events.on(Phaser.Scenes.Events.UPDATE, onUpdate)
  scene.events.once(Phaser.Scenes.Events.SHUTDOWN, cleanup)

  return { cancel }
}
